<template>
  <div class="mql-breadcrumb">
    <el-breadcrumb class="app-breadcrumb" separator="/">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item
          v-for="(item,index) in levelList"
          v-if="item.meta.title"
          :key="item.path"
        >
          <span
            v-if="item.redirect==='noredirect'||index==levelList.length-1"
            class="no-redirect"
          >{{item.meta.title}}</span>
          <a v-else @click.prevent="handleLink(item)" class="redirect">{{ item.meta.title }}</a>
        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
    <div class="mql-breadcrumb__right">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import pathToRegexp from "path-to-regexp";
export default {
  name: "MqlBreadcrumb",
  data() {
    return {
      levelList: null
    };
  },
  props: {
    pathId: {
      type: String,
      default: ""
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    }
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    curtail(arr) {
      var m = arr.slice(0);
      m.splice(0, 1);
      return m;
    },
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => {
        if (item.name || item.redirect) {
          return true;
        }
      });
      console.log(matched, "matched");
      console.log(this.curtail(matched))
      this.levelList = this.curtail(matched);
    },
    pathCompile(path) {
      const { params } = this.$route;
      var toPath = pathToRegexp.compile(path);
      return toPath(params);
    },
    handleLink(item) {
        console.log("准备跳转的地址",item)

      const { redirect, path } = item;
      console.log(path, "path");
      console.log(item, "item");

      if (redirect) {
        if (this.pathId && item.meta.title === '订单详情') {
          this.$router.push({
            name: "homeOrderListDetail",
            query: { id: this.pathId }
          });
          // this.$router.push({path:redirect,query:{id:this.pathId}})
        } else {

            console.log('准备跳转', redirect)
          this.$router.push(redirect);
        }
        return;
      }
      this.$router.push(this.pathCompile(path));
    }
  }
};
</script>

<style lang='scss' scoped>
.mql-breadcrumb {
  padding-left: 23px;
  padding-right: 30px;
  background-color: #f8f8f8;
  .app-breadcrumb.el-breadcrumb {
    display: inline-block;
    font-size: 14px;
    line-height: 50px;
    margin-left: 10px;
    .redirect {
      color: #3696fc;
    }
    .no-redirect {
      color: #97a8be;
      cursor: text;
    }
  }
  .mql-breadcrumb__right {
    float: right;
    height: 50px;
    line-height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlLayout/MqlBreadcrumb/index.vue